module.exports = "/call-frontend/img/trans_gpt.14c7394b.png";